import { intl } from '@fullstory/intl';
import React, { ComponentProps } from 'react';
import { IconButton } from '../../components/IconButton';
import { identifyComponent } from '../../util';
import { RestrictedComponent } from '../RestrictedComponent';

interface RestrictedIconButtonProps
  extends ComponentProps<typeof IconButton>,
    ComponentProps<typeof RestrictedComponent> {}

const defaultTooltip = intl.formatMessage({
  defaultMessage: 'Your account does not have permission to modify this value.',
  id: 'LO7MjK',
});
export const RestrictedIconButton: React.FC<RestrictedIconButtonProps> = ({
  tooltip = defaultTooltip,
  tooltipPlacement,
  enabledTooltipVariant,
  tooltipAction,
  ...buttonProps
}) => {
  const restrictedComponentProps: ComponentProps<typeof RestrictedComponent> = {
    tooltip,
    tooltipPlacement,
    tooltipAction,
    enabledTooltipVariant,
    disabled: buttonProps.disabled,
  };

  return (
    <RestrictedComponent
      data-component="RestrictedIconButton"
      {...restrictedComponentProps}
      {...identifyComponent('restricted-icon-button')}
    >
      <IconButton {...buttonProps} />
    </RestrictedComponent>
  );
};
